import React from "react"
import LaborAccessRequestExternal from "../../components/LaborAccessRequest/LaborAccessRequestExternal"

function LaborAccessRequestExternalPage() {
  return <LaborAccessRequestExternal />
}

export default LaborAccessRequestExternalPage
